<div class="p-5 space-y-6">

    <!-- Top stats -->
    <section class="grid gap-4 md:grid-cols-3">
        <div class="bg-white/5 dark:bg-white/5 backdrop-blur rounded-2xl p-5 border border-white/10">
            <div class="flex items-center justify-between">
                <h3 class="font-semibold text-sm opacity-80">Account Storage</h3>
                <span class="text-xs opacity-60">{{ usedPct() }}%</span>
            </div>
            <div class="mt-4">
                <div class="w-full h-2 rounded bg-gray-200 dark:bg-white/10 overflow-hidden">
                    <div class="h-2 bg-indigo-500 transition-all" [style.width.%]="usedPct()"></div>
                </div>
                <div class="mt-2 text-xs opacity-70">
                    {{ prettySize(totalBytes()) }} used • {{ prettySize(quotaBytes - totalBytes()) }} free of 80 GB
                </div>
            </div>
        </div>

        <div class="bg-white/5 backdrop-blur rounded-2xl p-5 border border-white/10">
            <div class="text-sm opacity-80">Files</div>
            <div class="mt-3 text-3xl font-semibold">{{ totalFiles() }}</div>
        </div>

        <div class="bg-white/5 backdrop-blur rounded-2xl p-5 border border-white/10">
            <div class="text-sm opacity-80">Avg. Size</div>
            <div class="mt-3 text-3xl font-semibold">
                {{ totalFiles() ? prettySize(totalBytes() / totalFiles()) : '—' }}
            </div>
        </div>
    </section>

    <!-- Uploader -->
    <section>
        <div
                class="rounded-2xl border-2 border-dashed transition-colors cursor-pointer"
                [class.border-indigo-500]="isDragging()"
                [class.border-gray-300]="!isDragging()"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave()"
                (drop)="onDrop($event)"
                (click)="fileInput.click()"
                role="button"
                tabindex="0"
                (keydown.enter)="fileInput.click()"
                (keydown.space)="fileInput.click()"
        >
            <div class="p-10 text-center">
                <div class="mx-auto w-14 h-14 rounded-full bg-indigo-500/10 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M16 12l-4-4m0 0l-4 4m4-4v12" />
                    </svg>
                </div>
                <p class="mt-4 font-medium">Drag & drop files here</p>
                <p class="text-sm opacity-70">or click to bfilese</p>
                <div class="mt-4">
                    <button
                            type="button"
                            class="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-sm hover:bg-indigo-500"
                            (click)="fileInput.click(); $event.stopPropagation()">
                        Select files
                    </button>
                    <input #fileInput type="file" class="hidden" multiple (change)="onBrowseChange($event)" />
                </div>
            </div>
        </div>

        <div class="mt-3 flex gap-2">
            <button
                    class="px-3 py-1.5 rounded-lg text-sm border border-gray-300 opacity-60 cursor-not-allowed"
                    (click)="clearAll()"
                    disabled
                    title="Disabled: files are managed by the backend">
                Clear list
            </button>
        </div>
    </section>

    <!-- Table -->
    <section class="bg-white/5 backdrop-blur rounded-2xl border border-white/10 overflow-hidden">
        <div class="overflow-x-auto">
            <table class="min-w-[720px] w-full text-sm">
                <thead class="bg-black/5 dark:bg-white/5">
                <tr class="text-left">
                    <th class="px-4 py-3 font-semibold">Name</th>
                    <th class="px-4 py-3 font-semibold w-40">Type</th>
                    <th class="px-4 py-3 font-semibold w-28">Size</th>
                    <th class="px-4 py-3 font-semibold w-56">Uploaded</th>
                    <th class="px-4 py-3 font-semibold w-56">Description</th>
                    <th class="px-4 py-3 font-semibold w-40">Actions</th>
                </tr>
                </thead>

                <tbody>
                    @for (file of fileList(); track file.id) {
                        <tr class="border-t border-white/10">
                            <td class="px-4 py-3">
                                <div class="flex items-center gap-2">
                                    <span class="inline-flex items-center justify-center w-6 h-6 rounded bg-gray-200/20">📄</span>
                                    <span class="font-medium truncate max-w-[380px]" [title]="file.name">{{ file.name }}</span>
                                </div>
                            </td>
                            <td class="px-4 py-3">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-200/20">
                  {{ file.type || 'Unknown' }}
                </span>
                            </td>
                            <td class="px-4 py-3">{{ prettySize(file.size) }}</td>
                            <td class="px-4 py-3">{{ file.addedAt | date: 'yyyy-MM-dd, HH:mm' }}</td>
                            <td class="px-4 py-3">
                                <div class="flex items-center gap-2">
                                    <input
                                        #descInput
                                        type="text"
                                        class="w-full px-2 py-1 text-sm rounded-md border border-gray-300
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           dark:bg-white/10 dark:border-white/20"
                                        placeholder="Add description…"
                                        [value]="file.description ?? ''"
                                        (input)="updateDescription(file.id, descInput.value)"
                                    />

                                    <button
                                            class="px-2 py-1 text-sm rounded-md border border-indigo-300 text-indigo-700
                           hover:bg-indigo-50 dark:hover:bg-indigo-500/10"
                                            (click)="saveDescription(file)"
                                            title="Save description">
                                        Save
                                    </button>
                                </div>
                            </td>
                            <td class="px-4 py-3">
                                <div class="flex gap-2">
                                    <button
                                            class="px-2 py-1 rounded-md border border-gray-300 hover:bg-gray-50 dark:hover:bg-white/10"
                                            (click)="download(file)"
                                            title="Download">
                                        ⬇️
                                    </button>
                                    <button
                                            class="px-2 py-1 rounded-md border border-rose-300 text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-500/10"
                                            (click)="remove(file)"
                                            title="Remove">
                                        🗑️
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }

                    @if (!fileList().length) {
                        <tr>
                            <td colspan="6" class="px-4 py-8 text-center opacity-70">
                                No files yet — upload some using the panel above.
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </section>

</div>
